module.exports = __webpack_public_path__ + "static/media/cost.bcf4e016.svg";